<template>
  <el-row type="flex" justify="center">
    <el-col :xs="24" :sm="16">
      <div>
        <el-card>
          <div slot="header"></div>
          <div v-if="page === 1">
            <q-title :title="title">
              <div v-html="subtitle"></div>
            </q-title>
            <div class="form">
              <el-form
                ref="form"
                :model="form"
                :rules="rules"
                label-position="left"
                size="medium"
              >
                <el-form-item label="单位" prop="company">
                  <el-input v-model="form.company"></el-input>
                </el-form-item>
                <el-form-item label="地方（地级及以上行政区域）" prop="region">
                  <el-input v-model="form.region"></el-input>
                </el-form-item>
                <el-form-item label="联系电话" prop="contact">
                  <el-input v-model="form.contact"></el-input>
                </el-form-item>
              </el-form>
            </div>
            <q-term align="center">
              <el-button type="primary" @click="nextPage">下一页</el-button>
              <span class="paginator-span">第1页/共2页</span>
            </q-term>
          </div>
          <div v-if="page === 2">
            <!-- 准备度 -->
            <q-term
              title="1. 准备度优秀案例"
              style="width: 95%; margin: 10px auto 0 auto;"
            >
            </q-term>
            <q-card v-model="q1" style="width: 95%; margin: 0 auto;"></q-card>
            <!-- 数据层 -->
            <q-term
              title="2. 数据层优秀案例"
              style="width: 95%; margin: 30px auto 0 auto;"
            >
            </q-term>
            <q-card v-model="q2" style="width: 95%; margin: 0 auto;"></q-card>

            <!-- 平台层 -->
            <q-term
              title="3. 平台层优秀案例"
              style="width: 95%; margin: 30px auto 0 auto;"
            >
            </q-term>
            <q-card v-model="q3" style="width: 95%; margin: 0 auto;"></q-card>

            <!-- 利用层 -->
            <q-term
              title="4. 利用优秀案例"
              style="width: 95%; margin: 30px auto 0 auto;"
            >
            </q-term>
            <q-card v-model="q4" style="width: 95%; margin: 0 auto;"></q-card>

            <!-- bottom page -->
            <q-term align="center">
              <el-button type="primary" @click="previousPage">上一页</el-button>
              <el-button type="primary" @click="onSubmit">提交</el-button>
              <span class="paginator-span">第2页/共2页</span>
            </q-term>
          </div>
        </el-card>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import QTitle from "./QTitle";
import QTerm from "./QTerm";
import QCard from "./QCard";
import { add0829 } from "@/api/questionaire";
export default {
  components: { QTerm, QTitle, QCard },
  data() {
    return {
      page: 1,
      title: "“中国开放数林指数”优秀案例征集表",
      subtitle: `<br>
                    “中国开放数林指数”意喻我国政府数据开放利用的生态体系，自2017年5月首次发布以来，每半年发布一次，定期对我国地方政府数据开放水平进行综合评价，精心测量各地“开放数木”的繁茂程度和果实价值，助推我国政府数据开放生态体系的建设与发展。
                    <br>
                    <br>
                    “中国开放数林指数“的成长，得到了各地的大力支持。2021年开放数林指数推出“数林四库”，指数制作方欢迎各地主动提供有关政府数据开放工作的优秀案例，经审核确认后以案例库中优秀案例的形式发布。`,
      form: {
        company: "",
        region: "",
        contact: ""
      },
      rules: {
        company: [{ required: true, message: "请填写此项", trigger: "blur" }],
        region: [{ required: true, message: "请填写此项", trigger: "blur" }],
        contact: [{ required: true, message: "请填写此项", trigger: "blur" }]
      },
      q1: [
        {
          title: "案例一",
          name: "",
          time: "",
          location: "",
          content: "",
          link: "",
          files: []
        }
      ],
      q2: [
        {
          title: "案例一",
          name: "",
          time: "",
          location: "",
          content: "",
          link: "",
          files: []
        }
      ],
      q3: [
        {
          title: "案例一",
          name: "",
          time: "",
          location: "",
          content: "",
          link: "",
          files: []
        }
      ],
      q4: [
        {
          title: "案例一",
          name: "",
          time: "",
          location: "",
          content: "",
          link: "",
          files: []
        }
      ]
    };
  },
  mounted() {
    console.log("env", process.env);
  },
  methods: {
    nextPage() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.page++;
        } else {
          //console.log("error submit!!");
          return false;
        }
      });
    },
    add() {
      console.log("add");
    },

    onSubmit() {
      const questionaire = {
        organization: this.form.company,
        city: this.form.region,
        phone: this.form.contact,
        prepare_cases: JSON.stringify(this.q1),
        data_cases: JSON.stringify(this.q2),
        platform_cases: JSON.stringify(this.q3),
        usage_cases: JSON.stringify(this.q4)
      };
      console.log(JSON.stringify(questionaire, 2));
      this.$alert("确认是否提交问卷", "提交", {
        confirmButtonText: "确定",
        callback: () => {
          add0829(questionaire)
            .then(response => {
              // console.log(response);
              const success = response.status === 200;
              this.$message({
                type: success ? "info" : "danger",
                message: success ? "提交成功" : response.msg
              });
            })
            .catch(err => {
              this.$message.error("提交错误 " + err);
            });
          console.log(questionaire);
        }
      });
    },
    previousPage() {
      this.page--;
    }
  }
};
</script>
<style>
.el-card__header {
  background-color: rgb(18, 98, 3);
}
.el-upload-dragger {
  height: 100%;
}
.form {
  width: 70%;
  margin: 45px 0 30px 0;
}
.table-less {
  width: 100%;
}
.table-less .el-input__inner {
  border: none;
  padding: 0;
}
.body {
  width: 60%;
}
.label {
  font-size: 0.14rem;
  white-space: pre-wrap;
  text-align: left;
  word-break: break-all;
  padding-bottom: 4px;
}
.item-space {
  margin-top: 25px;
}
.paginator-span {
  padding: 9px 0 0 38px;
  font-size: 13px;
  color: #999;
}
</style>
